module.exports = __webpack_public_path__ + "img/hum_pack.8f722ee0.png";